export default __webpack_public_path__ + "static/aws-deepracer-banner-086f48ef27b151c3280d11bd03b9be34.jpg";